// Spacing & Radius tokens — Design System v3
// Règle : jamais pill sur les boutons. Pill réservé aux chips et avatars.

// Échelle sur la grille 4px. S'étend jusqu'à 96 : l'ancien plafond à 40
// forçait les grands espacements (sections, illustrations, empty states) à des
// littéraux hors échelle (72, 88…). Un espacement de LAYOUT doit toujours
// piocher ici ; seul le padding INTERNE d'un composant peut dévier pour que la
// hauteur finale retombe sur la grille (ex. 14+14+20 = 48).
export const spacing = {
  xs:   4,
  sm:   8,
  md:   12,
  lg:   16,
  xl:   20,
  "2xl": 24,
  "3xl": 28,
  "4xl": 32,
  "5xl": 40,
  "6xl": 48,
  "7xl": 56,
  "8xl": 64,
  "9xl": 96,
} as const;

export const radius = {
  xs:   6,   // micro éléments
  sm:   10,  // badges, chips
  input: 12, // inputs & formulaires
  btn:  14,  // boutons — jamais pill
  lg:   16,
  card: 18,  // cards
  xl:   20,
  "2xl": 24, // SOS FAB
  pill: 999, // chips, avatars UNIQUEMENT
} as const;

// Tailles de boutons
export const buttonSize = {
  sm: 36,
  md: 48,
  lg: 56,
} as const;
